import httpClient from "../../../api/httpClient";

// System users are ops-managed integration accounts (EDI, camera gates) — see
// SystemUserController on the backend, gated entirely by the "systemUsers:MANAGE" privilege
// (held only by the "Ascend Cargo System Admin" role). httpClient already attaches the JWT via
// its request interceptor, so no manual Authorization header is needed here.

export const listSystemUsers = (officeCode) =>
    httpClient.get(`/api/internal/system-users`, { params: { officeCode } });

export const createSystemUser = (officeCode, label, roleIds = []) =>
    httpClient.post(`/api/internal/system-users`, { officeCode, label, roleIds });

export const rotateSystemUserToken = (id) =>
    httpClient.post(`/api/internal/system-users/${id}/rotate-token`, {});

export const deactivateSystemUser = (id) =>
    httpClient.delete(`/api/internal/system-users/${id}`);

export const reactivateSystemUser = (id) =>
    httpClient.post(`/api/internal/system-users/${id}/reactivate`, {});
